
import CreateCustomerModule from "modules/Admin/customers/CreateCustomer"

function CreateCustomerPage() {
  return (
    <div data-testid="adminCreateCustomerPage">
      <CreateCustomerModule />
    </div>
  )
}

export default CreateCustomerPage